module.exports = __webpack_public_path__ + "static/talisman_of_ultimate_evil-e6bddd6f70a90a2bc4175a56699376a7.jpeg";